<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Attribut</mat-label>
            <mat-select formControlName="attribute" required tabindex="1">
                <mat-option *ngFor="let attribute of _attributes" [value]="attribute.id">
                    {{ attribute.header }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="dataForm.controls['attribute']?.errors?.required && (dataForm.controls['attribute']?.dirty || dataForm.controls['attribute'].touched)">
                Le champ 'Attribut' est obligatoire
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO attribute" matTooltipPosition="right"></fa-icon>
    </div>
</form>
